import PropTypes from "prop-types";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import service from "undefined-service-web";
import { useDispatch } from "react-redux";
import { setAuthUser } from "../../store/reducers/actions.js";
const AuthGuard = ({ children }) => {
  const dispatch = useDispatch();
  const { authUser } = useSelector(({ auth }) => auth);
  const navigate = useNavigate();

  useEffect(() => {
    let token = localStorage.getItem("token");
    if (service.isNullOrEmpty(authUser) && service.isNullOrEmpty(token)) {
      navigate("/", { replace: true });
    } else if (!service.isNullOrEmpty(token)) {
      dispatch(setAuthUser(token));
      // console.log(window.location.pathname)
      if (window.location.pathname === "/") {
        navigate("main/home", { replace: true });
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authUser, navigate]);

  return children;
};

AuthGuard.propTypes = {
  children: PropTypes.node,
};

export default AuthGuard;
